<template>
	<div class="content">
		<div class="tableTit">
			<p class="tabtitBg"></p>
			<h6>防汛值班</h6>
			<el-button class="titBtn" type="primary" icon="el-icon-plus" @click="addClick()">添加值班</el-button>
			<!-- <el-button class="titBtn" type="success" icon="el-icon-search">搜索</el-button> -->
			<!-- <el-input class="querys" v-model.trim="dw" placeholder="值班表标题"></el-input> -->
      <addressTree @obj="objdata" @close="treeClose"></addressTree>
		</div>
		<div class="tabBody">
			<el-table :data="tabledata" :height="tableHeight" border :header-cell-style="{background:'rgba(49,130,222,0.1)'}">
				<el-table-column type="index" align="center" width="45" label="序号"></el-table-column>
        <el-table-column prop="ydbName" align="center" label="淤地坝名称"></el-table-column>
				<el-table-column prop="ydbGldw" align="center" label="部门"></el-table-column>
				<el-table-column prop="ydbZbryMz" align="center" label="值班人员"></el-table-column>
				<el-table-column prop="ydbZbfzrMz" align="center" label="值班领导"></el-table-column>
				<el-table-column prop="ydbZbkssj" align="center" label="开始时间"></el-table-column>
				<el-table-column prop="ydbZbjssj" align="center" label="结束时间"></el-table-column>
        <el-table-column prop="status" label="状态" width="85px" align="center">
          <template slot-scope="scope">
            <p v-if="scope.row.status==1" class="zxfonte">未执行</p>
            <p v-if="scope.row.status==0" class="zxfontb"><span class="fa fa-check fafongt"></span>已执行</p>
          </template>
        </el-table-column>
				<el-table-column label="操作" width="90" align="center">
					<template slot-scope="scope">
						<el-button type="success" class="tableedit" icon="el-icon-edit" circle @click="edits(scope.row,scope.$index)"></el-button>
						<el-button type="warning" class="tableedit" icon="el-icon-delete" circle @click="deletes(scope.row,scope.$index)"></el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="fye">
			<pagintion @dsydata='DsyData' @dstdata="DstData" :ToTal='total' :pageNums="pageNums"></pagintion>
		</div>
		<beondutypopup v-if="dialogVisible == true" :mystate="Addsid" @bjadddata="Bjadddata" @getcancel="Getcancel" @adddata="Adddata"></beondutypopup>
	</div>
</template>

<script>
  import { fxzbList, fxzbDelete } from "@/api/api";
  import addressTree from '@/components/mangement/addressTree.vue';
	import pagintion from '@/components/mangement/pagintion.vue';
	import beondutypopup from '../popup/beondutypopup.vue'

	export default{
		data(){
			return{
				dw:'',
				tabledata: [],
				tableHeight: window.innerHeight - 180,
				total: 0,
				pageSize: 20, //每页多少条数据分页
				pageNum: 1, //当前页
				pageNums: null,
				username: '',
				dw: '',
				dialogVisible: false,
				Addsid: [],
			}
		},
		components: {
      addressTree,
			pagintion,
			beondutypopup
		},
		mounted() {
      let params = {
      	pageSize: this.pageSize,
      	pageNum: this.pageNum,
      }
      this.list(params);
		},
		methods: {
      //调用接口获得防汛值班列表
      list(params) {
      	fxzbList(params).then((res) => {
          this.total = res.total;
          this.tabledata = res.data;
      	})
      },
			Getcancel(data) {
				this.dialogVisible = data.dialogVisible;
			},
			addClick(){
        this.Addsid = [];
        this.dialogVisible = true;
        this.Addsid.push('xz');
			},
      edits(row, index) {
        this.Addsid = [];
        this.dialogVisible = true;
        this.Addsid.push('bj', row);
      },
      deletes(row, index) {
      	this.$confirm('确定删除当前用户吗?此操作将永久删除, 是否继续?', '提示', {
      		confirmButtonText: '确定',
      		cancelButtonText: '取消',
      		type: 'warning'
      	}).then(action => {
      		if(action === 'confirm') {
            let ids = [];
            ids.push(row.id);
      			fxzbDelete(ids).then((res) => {
      				if(res.code == 200) {
      					this.$notify({
      						title: "提示",
      						message: res.message,
      						type: "success",
      					});
      					let params = {
      						pageSize: this.pageSize,
      						pageNum: this.pageNum,
      					}
      					this.list(params)
      				} else {
      					this.$notify({
      						title: "提示",
      						message: res.message,
      						type: "success",
      					});
      				}
      			})
      		}
      	}).catch(() => {
      		this.$message({
      			message: '已取消',
      			type: 'warning'
      		});
      	});
      },
      treeClose() {
        let params = {
          pageSize: this.pageSize,
          pageNum: this.pageNum,
        }
        this.list(params)
      },
      objdata(data) {
        let params = {
          pageSize: this.pageSize,
          pageNum: this.pageNum,
          ydbCode: data.ydbCode
        }
        this.list(params)
      },
			Bjadddata(data) {
				this.dialogVisible = data.dialogVisible;
        let params={
        	pageSize: this.pageSize,
        	pageNum: this.pageNum,
        }
        this.list(params);
			},
			Adddata(data){
        this.dialogVisible = data.dialogVisible;
        let params={
        	pageSize: this.pageSize,
        	pageNum: this.pageNum,
        }
        this.list(params);
			},
      DsyData(data) { //多少页
      	this.pageNum = data.dsy;
      	let params = {
      		pageSize: this.pageSize,
      		pageNum: this.pageNum,
      	}
        this.list(params)
      },
      DstData(data) { //多少条
      	this.pageSize = data.dst;
      	let params = {
      		pageSize: this.pageSize,
      		pageNum: this.pageNum,
      	}
        this.list(params)
      },
		}
	}
</script>

<style scoped>
	@import url('../../../common/css/mangementall.css');
	.querys {
		height: 30px;
		float: right;
		width: 200px;
		margin-top: 10px;
		margin-right: 10px;
	}

	>>>.el-input__inner {
		height: 30px;
		line-height: 30px;
		color: #606266;
		font-size: 14px;
	}

</style>
